import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from 'reactstrap';

const ModalLeerOrdenCompra = ({ isOpen, toggle, selectedOrdenCompra }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Ver Orden de Compra</ModalHeader>
            <ModalBody>
                {selectedOrdenCompra ? (
                    <div>
                        <Row>
                            <Col md={6}><strong>Empresa:</strong> {selectedOrdenCompra.CLAEMP}</Col>
                            <Col md={6}><strong>Número Orden:</strong> {selectedOrdenCompra.NROODC}</Col>
                        </Row>
                        <Row>
                            <Col md={6}><strong>Tipo Orden:</strong> {selectedOrdenCompra.TIPODC}</Col>
                            <Col md={6}><strong>Fecha Orden:</strong> {selectedOrdenCompra.FECODC}</Col>
                        </Row>
                        <Row>
                            <Col md={6}><strong>Estado:</strong> {selectedOrdenCompra.ESTADO}</Col>
                            <Col md={6}><strong>Valor Total:</strong> {selectedOrdenCompra.VALTOT}</Col>
                        </Row>
                        {/* Add more fields as needed */}
                    </div>
                ) : (
                    <p>No se ha seleccionado una orden de compra.</p>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cerrar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalLeerOrdenCompra;